import React, { useState, useContext, useEffect } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleDown, faTrash } from "@fortawesome/free-solid-svg-icons";
import { currencyFormat, i18nValue } from "../../functions";
import { T } from "react-translator-component";
import { HotelContext } from "../../context/hotel"; 
import { usePerson, publicBookablePersonSchema } from "../../context/person";
import { useMemo } from "react";
import * as Yup from "yup";

const PublicCartSummary = ({
    cart,
    cartItemsCustomizations,
    setCartItemsCustomizations,
    summary,
    // setSummary,
    setOpenModal,
    language,
    observations,
    setObservations,
    handleDeleteItem,
    isEdit = false
}) => {
    const [customizations, setCustomizations] = useState({});
    const [comments, setComments] = useState("");
    const [errors, setErrors] = useState({});
    const { data: { id: hotelId }, currency } = useContext(HotelContext);

    const isInputDisabled = useMemo(() => {
        return localStorage.getItem(`ViCo::token-${hotelId}-person`) ? true : false;
    }, [hotelId]);

    const { data: person, setData: setPerson } = usePerson();

    useEffect(() => {

        console.log('CartSummary - cart', cart);
        console.log('CartSummary - cartItemsCustomizations', cartItemsCustomizations);

        let auxCustomsItems = {};
        cart.items?.map((el) => {
            if (el.customizations) {

                el.customizations.map((item, index) => {
                    Object.keys(item).map((key, idx) => {

                        if (el.preferences?.[key]) {
                            auxCustomsItems = {
                                ...auxCustomsItems,
                                [el.itemId]: {
                                    ...(auxCustomsItems[el.itemId] || {}),
                                    [index]: {
                                        ...(auxCustomsItems[el.itemId]?.[index] || {}),
                                        [key]: item[key],
                                    },
                                },
                            };
                        }
                        
                    });
                });

            }
        });

        setCustomizations(auxCustomsItems);
  
    }, []);

    useEffect(() => {
        console.log('CartSummary - customizations', customizations);
    }, [customizations]);
    
    // const handleClose = () => {
    //     setSummary(false);
    // };

    const handleObservationChange = (e) => {
        setObservations(e.target.value);
    };

    const handleOptionSelect = (itemId, idx, prefId, optId) => {
        setCustomizations((prevCustomizations) => {
            const updatedCustomizations = {
                ...prevCustomizations,
                [itemId]: {
                    ...(prevCustomizations[itemId] || {}),
                    [idx]: {
                        ...(prevCustomizations[itemId]?.[idx] || {}),
                        [prefId]: optId,
                    },
                },
            };

            const transformedCustomizations = Object.keys(updatedCustomizations).reduce(
                (acc, currentItemId) => {
                    const currentItemCustomizations = updatedCustomizations[currentItemId];

                    const currentItemTransformed = Object.keys(
                        currentItemCustomizations
                    ).reduce((itemAcc, currentIdx) => {
                        const currentCustomization = currentItemCustomizations[currentIdx];

                        itemAcc[currentIdx] = currentCustomization;
                        return itemAcc;
                    }, {});

                    acc[currentItemId] = currentItemTransformed;
                    return acc;
                },
                {}
            );
            return transformedCustomizations;
        });
    };

    const handleSummaryDeleteItem = (itemId, index) => {

        // Remuevo customización
        let auxCustomizations = { ...customizations};
        if (auxCustomizations?.[itemId]?.[index]) {
            auxCustomizations[itemId] = removeAndReorder(auxCustomizations[itemId], index);
            setCustomizations(auxCustomizations);
        }

        handleDeleteItem(itemId);
    }

    const removeAndReorder = (obj, keyToRemove) => {
        const updatedObj = {};
        // const targetObj = obj["37bde9b3-5023-441f-8265-e6fc85ba6a8b"];
    
        let index = 0;
        for (const key in obj) {
          if (key != keyToRemove) {
            updatedObj[index] = obj[key];
            index++;
          }
        }
    
        obj = updatedObj;
        return obj;
    }

    // Schema con validación adicional para location y tent (requeridos solo en PublicCartSummary)
    const cartSummaryPersonSchema = Yup.object().shape({
        fullname: Yup.string()
            .min(2, "yup.minimal-2-letters")
            .max(50, "yup.maximal-50-letters")
            .matches(/^[a-zA-ZáéíóúñÁÉÍÓÚÑ\s]*$/, "yup.only-letters")
            .required("yup.required"),
        phone: Yup.string()
            .matches(/^\d+$/, "yup.only-numbers")
            .required("yup.required"),
        email: Yup.string()
            .email("yup.email-invalid-format")
            .required("yup.required"),
        location: Yup.string()
            .required("yup.required"),
        tent: Yup.string()
            .required("yup.required")
    });

    // Función para validar los datos
    const validateData = async (data) => {
        let res = false;
        console.log('0201 - data', data);
        try {
            await cartSummaryPersonSchema.validate(data, { abortEarly: false }); // Validar todo el objeto
            setErrors({});
            console.log("✅ Datos válidos");
            res = true;
        } catch (error) {
            console.log("❌ Errores de validación:");
            const errorMessages = {};
            error.inner.forEach((err) => {
                errorMessages[err.path] = err.message;
            });
            setErrors(errorMessages);
        }
        return res;
    };

    return (
        <>
        
            {summary && cart?.items && (
                <div
                    className="cart-container fixed p-3"
                    style={{
                        position: 'fixed',
                        top: 50,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        zIndex: 999,
                        overflowY: 'auto',
                    }}
                >

                    <div className="d-flex flex-column">
                          <>
                             {/* inicio datos personales */}
                             {!isInputDisabled && (<>
                             <div class="cart-label d-flex justify-content-between align-items-center">
                                    <div class="p-2">
                                        <span class="cart-title" style={{ fontWeight: "600" }}>{T("public.personal-information")}</span>
                                    </div>
                                </div>
                                <div className='mb-2'>
                                    <Form.Control
                                        value={person?.fullname || ""}
                                        placeholder={`${T("public.input.name-and-surname")}...`}
                                        className={`mr-1`}
                                        style={{ border: errors.fullname && "1px solid #dc3545" }}
                                        onChange={(event) => {
                                            // Solo permite letras, espacios y caracteres acentuados
                                            const filteredValue = event.target.value.replace(/[^a-zA-ZáéíóúñÁÉÍÓÚÑ\s]/g, '');
                                            setPerson({ ...person, fullname: filteredValue })
                                        }}
                                        //Si hay person token en el localStorage, deshabilitar el input
                                        disabled={isInputDisabled}
                                        required={true}
                                    ></Form.Control>
                                    {errors.fullname && <p className="pl-2 font-size-sm text-danger">{T(errors.fullname)}</p>}
                                </div>
                                <div className='mb-2'>
                                    <Form.Control
                                        value={person?.phone || ""}
                                        placeholder={`${T("public.input.phone")}...`}
                                        className={`mr-1`}
                                        style={{ border: errors.phone && "1px solid #dc3545" }}
                                        onChange={(event) => {
                                            // Solo permite números
                                            const filteredValue = event.target.value.replace(/\D/g, '');
                                            setPerson({ ...person, phone: filteredValue })
                                        }}
                                        disabled={isInputDisabled}
                                        required={true}
                                    ></Form.Control>
                                    {errors.phone && <p className="pl-2 font-size-sm text-danger">{T(errors.phone)}</p>}
                                </div>

                                <div className='mb-2'>
                                    <Form.Control
                                        value={person?.email || ""}
                                        placeholder={`${T("public.input.email")}...`}
                                        style={{ border: errors.email && "1px solid #dc3545" }}
                                        onChange={(event) => {
                                            setPerson({ ...person, email: event.target.value })
                                        }}
                                        disabled={isInputDisabled}
                                    ></Form.Control>
                                    {errors.email && <p className="pl-2 font-size-sm text-danger">{T(errors.email)}</p>}
                                </div>
                                </>)}
                                {/* fin datos personales */}
                                <div class="cart-label d-flex justify-content-between align-items-center">
                                    <div class="p-2">
                                        <span class="cart-title" style={{ fontWeight: "600" }}>{T("request.delivery-point")}</span>
                                    </div>
                                </div>
                                {/* inicio datos ubicación */}
                                <div style={{ background: "#e7e7e7", padding: "10px", borderRadius: "8px" }}>
                                    <div className="row">
                                        <div className='col-8'>
                                            {/* Sombrilla arena (sa), Sombrilla piscina (sp) y Carpa (c) */}
                                            <Form.Control
                                                as={"select"}
                                                value={person?.location || ""}
                                                placeholder={`${T("public.input.location")}...`}
                                                className={`mr-1`}
                                                style={{ border: errors.location && "1px solid #dc3545" }}
                                                onChange={(event) => {
                                                    setPerson({ ...person, location: event.target.value })
                                                }}
                                                required={true}
                                            >
                                                <option value="">{T("select...")}</option>
                                                <option value="sa">{T("public.input.location.arena")}</option>
                                                <option value="sp">{T("public.input.location.piscina")}</option>
                                                <option value="c">{T("public.input.location.carpa")}</option>
                                            </Form.Control>
                                            {errors.location && <p className="pl-2 font-size-sm text-danger">{T(errors.location)}</p>}
                                        </div>
                                        <div className='col-4'>
                                            <Form.Control
                                                value={person?.tent || ""}
                                                placeholder={`${T("public.input.number")}`}
                                                className={`mr-1`}
                                                style={{ border: errors.tent && "1px solid #dc3545" }}
                                                onChange={(event) => {
                                                    setPerson({ ...person, tent: event.target.value })
                                                }}
                                                required={true}
                                            ></Form.Control>
                                            {errors.tent && <p className="pl-2 font-size-sm text-danger">{T(errors.tent)}</p>}
                                        </div>
                                    </div>
                                </div>
                                {/* fin datos ubicación */}
                            </>
                    </div>

                    {/* separator */}
                    <div className="separator"></div>
                    <div className="cart-label d-flex justify-content-between align-items-center">
                        {/* <div className="cart-title p-2 ">{T('request.your-request')}</div> */}
                        <div className="p-2">
                        <span className="cart-title">{T("request.your-request")}</span>
                        <small clasName="text-muted">{` (${cart?.qty} ${cart?.qty > 1 ? T("request.products") : T("request.product")})`}</small>
                        </div>
                        {/* <Button size="sm" onClick={handleClose}>
                            <FontAwesomeIcon
                                icon={faArrowAltCircleDown}
                                color="white"
                                size="2x"
                            />
                        </Button> */}
                    </div>
                    {(() => {
                        return cart.items.flatMap((item, idx) =>
                            Array.from({ length: item.qty }, (_, index) => {
                                return (
                                    <Card key={item.itemId + '_' + index} className="my-2">
                                        <Card.Body className="p-2">
                                            <div className="p-1">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <div className="general-text text-uppercase">
                                                        <small className="cart-title mr-1"><small>#</small>{(idx + 1) + index}</small>
                                                        <b>{item.name}</b>
                                                    </div>
                                            <button
                                                style={{
                                                    background: "none",
                                                    border: "none",
                                                    width: "20px",
                                                    // height: "20px"
                                                }}
                                                onClick={() => { handleSummaryDeleteItem(item.itemId, index) }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faTrash}
                                                    color="red"
                                                />
                                            </button>
                                        </div>
                                        <div>
                                            <Card.Text>
                                                <span className="general-text text-muted font-size-sm d-block" style={{ lineHeight: 1.25 }}>
                                                    {item.desc}
                                                </span>
                                            </Card.Text>
                                            {item.preferences && Object.keys(item.preferences).map((prefId, idx) => {
                                                const p = item.preferences[prefId];
                                                return (
                                                    <React.Fragment key={prefId}>
                                                        <p className="mb-1 font-size-sm"><b>{i18nValue(p, "title", language)}</b></p>
                                                        <Form.Control
                                                            as={"select"}
                                                            className="mb-2 font-size-sm"
                                                            value={customizations?.[item.itemId]?.[index]?.[prefId] || ""}
                                                            onChange={(event) => {
                                                                handleOptionSelect(
                                                                    item.itemId,
                                                                    index,
                                                                    prefId,
                                                                    event.target.value
                                                                )
                                                            }}
                                                        >
                                                            <option value="">{T("select...")}</option>
                                                            {p.options && Object.keys(p.options).map((optionId) => (
                                                                <option key={optionId} value={optionId}>{i18nValue(p.options[optionId], "value", language)}</option>
                                                            ))}
                                                        </Form.Control>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                        <div className="d-flex flex-column align-items-end">
                                            <span className="general-text text-muted mt-2">
                                                <b>{currencyFormat(item.price, currency)}</b>
                                            </span>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                                );
                            })
                        );
                    })()}
                    <div className="observations p-1">
                        <Form.Label className="cart-label">
                            {T('request.observations')}
                        </Form.Label>
                        <Form.Control
                            className="font-size-sm"
                            as="textarea"
                            rows={3}
                            placeholder={T("request.observations-placeholder")}
                            value={observations || ""}
                            onChange={(e) => {
                                handleObservationChange(e)
                            }}
                        />
                    </div>
                    <div className="subtotal cart-label mt-2 mx-1 font-size-md" style={{ textAlign: 'right', marginBottom: 60 }}>
                        {T('general.total')}: <b>{currencyFormat(cart.total, currency)}</b>
                    </div>
                    <div className="fixed-bottom py-3 px-4">
                        <Button
                            size={'lg'}
                            variant={'success'}
                            type={'button'}
                            block={true}
                            className={'cart-go-resume'}
                            onClick={async () => {
                                const isValid = await validateData({
                                    fullname: person?.fullname,
                                    phone: person?.phone,
                                    email: person?.email,
                                    location: person?.location,
                                    tent: person?.tent
                                });
                                if (isValid) {
                                    setCartItemsCustomizations(customizations);
                                    setOpenModal(true);
                                }
                            }}
                        >
                            { T(isEdit ? 'general.updateOrder' : 'general.placeOrder') }
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default PublicCartSummary;
